import Marquee from "react-fast-marquee";

const ITEMS = ["FLIGHTS", "5-STAR HOTELS", "PRIVATE TRANSFERS", "GUIDED SIGHTSEEING", "VIP CONCIERGE", "VISA ASSISTANCE"];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/10 bg-onyx-800/50 py-5 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-mono text-sm uppercase tracking-[0.35em] text-gold/70 px-8">{item}</span>
            <span className="text-gold/40 text-xs">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
